import "./FormComponents.css";
import React, { useState, useEffect, useRef } from "react";
import rightArrow from "../../assets/arrow-right.svg";
import leftArrow from "../../assets/arrow-left.svg";
import submittedIcon from "../../assets/submittedIcon.svg";
import dropdownArrow from "../../assets/dropdown-icon.svg";

export const FormButtons = ({ children }) => {
  return <div className="buttons-wrapper">{children}</div>;
};

export const CancelButton = ({ name, onClick }) => {
  return (
    <button className="cancel-button" onClick={onClick}>
      <span>{name}</span>
      <img src={leftArrow} alt="right-arrow"></img>
    </button>
  );
};

export const SubmitButton = ({ name, boolVar = true, onClick }) => {
  return (
    <button
      className="submit-button"
      onClick={onClick}
      style={{
        cursor: boolVar ? "pointer" : "not-allowed",
        background: boolVar ? "#0445d2" : "#0445d2",
        transform: boolVar ? "" : "none",
        boxShadow: boolVar ? "" : "none",
      }}
    >
      <span>{name}</span>
      <img src={rightArrow} alt="right-arrow"></img>
    </button>
  );
};

export default function FormHeading(props) {
  return (
    <div className="form-heading">
      <h3> {props.h3} </h3>
      <p> {props.p} </p>
    </div>
  );
}

export const ProgressBar = ({ progress = 0 }) => {
  return (
    <div
      className="progress-bar-container"
      style={{ background: progress ? "#eee" : "#fff" }}
    >
      <div className="progress-bar" style={{ width: `${progress}%` }} />
    </div>
  );
};

export const InputBox = ({ handleInputAnswer }) => {
  const [inputData, setInputData] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setInputData(e.target.value);
    setError(false);
  };
  const handleSubmit = () => {
    if (!inputData) {
      setError(true);
    } else handleInputAnswer(inputData);
  };
  return (
    <div className="input-box">
      <input
        type="text"
        value={inputData}
        autoComplete="off"
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit(e); // Call handleSubmit if Enter key is pressed
          }
        }}
      />

      <button className="send-button" onClick={handleSubmit}>
        <span> Submit </span>
      </button>
      {error && (
        <span className="error-message" style={{ left: 0 }}>
          Please enter a specific value
        </span>
      )}
    </div>
  );
};

export const ScheduledInfo = ({
  dateSelected,
  timeSelected,
  timeZoneSelected,
  children,
}) => {
  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "long" });
    const weekday = date.toLocaleString("en-GB", { weekday: "short" });

    return {
      day,
      month,
      weekday,
    };
  };

  const { day, month, weekday } = formatDate(dateSelected);

  return (
    <div className="scheduled-for">
      {children}
      <div className="scheduled-date-time">
        <div className="scheduled-date">
          <h1 className="date-day">{day}</h1>
          <div className="month-weekday-wrapper">
            <h4 className="date-month">{month}</h4>
            <p className="date-weekday">{weekday}</p>
          </div>
        </div>
        <div className="scheduled-time">
          <div className="time-label">
            <span>Time</span>
          </div>
          <p className="time-details">
            {timeSelected} ({timeZoneSelected})
          </p>
        </div>
      </div>
    </div>
  );
};

export const SubmittedBox = ({
  setStep,
  dateSelected,
  timeSelected,
  timeZoneSelected,
}) => {
  return (
    <div className="submitted-box-overlay">
      <div className="submitted-box">
        <ScheduledInfo
          dateSelected={dateSelected}
          timeSelected={timeSelected}
          timeZoneSelected={timeZoneSelected}
        >
          <img src={submittedIcon} alt="Check Icon" />
        </ScheduledInfo>
        <div className="submitted-message">
          <h2>Demo Successfully Scheduled!</h2>
          <p>
            Our demo has been successfully booked. We look forward to showcasing
            how XenonStack can transform your business.
          </p>
          <button
            className="done-button"
            onClick={() => {
              window.location.href =
                document.referrer || "https://www.xenonstack.com/";
            }}
          >
            <span>Done</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export const TimeZoneDropdown = ({
  setTimeZoneSelected,
  timeAvalilability,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [timeZone, setTimeZone] = useState("GMT+05:30");
  const timezones = [
    "GMT-11:00",
    "GMT-10:00",
    "GMT-09:00",
    "GMT-08:00",
    "GMT-07:00",
    "GMT-06:00",
    "GMT-05:00",
    "GMT-04:00",
    "GMT-03:00",
    "GMT-02:00",
    "GMT-01:00",
    "GMT±00:00",
    "GMT+01:00",
    "GMT+02:00",
    "GMT+03:00",
    "GMT+04:00",
    "GMT+05:00",
    "GMT+05:30",
  ];
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    if (!timeAvalilability) {
      alert("Select a time slot");
      return;
    }
    setIsOpen(!isOpen);
  };

  const handleTimeZoneClick = (timezone) => {
    const timeZonePicked = timezone;
    setTimeZone(timeZonePicked);
    setTimeZoneSelected(timeZonePicked);

    toggleDropdown();
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        <span>{timeZone}</span>
        <img src={dropdownArrow} alt="Dropdown Arrow" />
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          {timezones.map((timezone, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => handleTimeZoneClick(timezone)}
            >
              <p>{timezone}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const PickTime = ({
  setTimeSelected,
  setTimeZoneSelected,
  setDurationSelected,
  selectedDate,
  selectedTimeZone
}) => {
  const [timeSlot, setTimeSlot] = useState(null);
  const [duration, setDuration] = useState(0);
  const slots = timeSlots[duration];
  const timeSlotsRef = useRef(null);
  const handleClick = (e, index) => {
    const originalSlot = slots[index - 1];

    // Check if the slot is disabled based on the original slot time
    if (isWeekend() || (isSelectedDateToday() && isSlotDisabled(originalSlot))) {
      return;
    }

    // Get the converted time that's displayed to the user
    const convertedSlot = convertTimeZone(originalSlot, selectedTimeZone, "GMT+5:30");
    setTimeSlot(index);
    setTimeSelected(convertedSlot);
  };

  const parseTime = (timeStr) => {
    const [startTime] = timeStr.split(" - ");
    const [hour, minute, period] = startTime.split(/[:\s]/);
    let hours = parseInt(hour, 10);
    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;
    return new Date().setHours(hours, parseInt(minute, 10), 0, 0);
  };
  const isSlotDisabled = (slotTime) => {
    const now = new Date();
    if (isWeekend()) return true;
    if (isSelectedDateToday()) {
      return parseTime(slotTime) < now.getTime();
    }
    return false;
  };

  const isSelectedDateToday = () => {
    const today = new Date();
    return (
      selectedDate &&
      today.getFullYear() === selectedDate.getFullYear() &&
      today.getMonth() === selectedDate.getMonth() &&
      today.getDate() === selectedDate.getDate()
    );
  };

  const isWeekend = () => {
    const date = selectedDate;
    const day = date.getDay();
    return day === 0 || day === 6;
  };
  const hasAvailableSlots = () => {
    if (isWeekend()) {
      return false;
    }
    return slots.some((slot) => !isSlotDisabled(slot));
  };
  useEffect(() => {
    const hasAvailableSlot = hasAvailableSlots();

    if (hasAvailableSlot) {
      let slotIndex = -1;
      const firstAvailableIndex = slots.findIndex((slot) => !isSlotDisabled(slot));
      if (isSelectedDateToday()) {
        slotIndex = firstAvailableIndex;
      } else {
        slotIndex = 0;
      }
      if (timeSlot === null && slotIndex !== -1) {
        if (isWeekend()) return;
        // Convert the time slot before setting it
        const convertedSlot = convertTimeZone(slots[slotIndex], selectedTimeZone, "GMT+5:30");
        setTimeSelected(convertedSlot);
        setTimeSlot(slotIndex + 1);
      } else if (timeSlot !== null) {
        // Convert the time slot before setting it
        const convertedSlot = convertTimeZone(slots[slotIndex], selectedTimeZone, "GMT+5:30");
        setTimeSelected(convertedSlot);
        setTimeSlot(slotIndex + 1);
      } else {
        if (timeSlot && timeSlot > 0) {
          const slotToConvert = slots[timeSlot - 1] || "No available time slots for the date selected";
          const convertedSlot = typeof slotToConvert === 'string' && slotToConvert.includes('-')
            ? convertTimeZone(slotToConvert, selectedTimeZone, "GMT+5:30")
            : slotToConvert;
          setTimeSelected(convertedSlot);
        } else {
          setTimeSelected("No available time slots for the date selected");
        }
      }
    } else {
      setTimeSelected("No available time slots for the date selected");
    }
    // eslint-disable-next-line
  }, [duration, selectedDate, selectedTimeZone]);


  useEffect(() => {
    if (timeSlotsRef.current) {
      const firstAvailableIndex = slots.findIndex((slot) => !isSlotDisabled(slot));
      if (firstAvailableIndex !== -1) {
        const firstAvailableElement = timeSlotsRef.current.children[firstAvailableIndex];
        if (firstAvailableElement) {
          firstAvailableElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }
    }
    // eslint-disable-next-line
  }, [duration, selectedDate]);
  const handleDuration = (e, index) => {
    setDuration(index);
    setDurationSelected(e.target.innerText);
  };

function convertTimeZone(timeString, selectedTimeZone, baseTimeZone = "GMT+5:30") {
    if (!timeString || !timeString.includes(" - ")) {
      return timeString;
    }

     const parseTimeZone = (tzString) => {
      const match = tzString.match(/GMT([+-])(\d+):(\d+)/i);
      if (!match) return { sign: 1, hours: 0, minutes: 0 };

      const sign = match[1] === '+' ? 1 : -1;
      const hours = parseInt(match[2], 10);
      const minutes = parseInt(match[3], 10);

      return { sign, hours, minutes };
    };

    const selected = parseTimeZone(selectedTimeZone);
    const base = parseTimeZone(baseTimeZone);
    const selectedMinutes = selected.sign * (selected.hours * 60 + selected.minutes);
    const baseMinutes = base.sign * (base.hours * 60 + base.minutes);
    const diffMinutes = selectedMinutes - baseMinutes;

    const hoursDiff = Math.floor(Math.abs(diffMinutes) / 60);
    const minutesDiff = Math.abs(diffMinutes) % 60;

    const hoursToAdd = diffMinutes < 0 ? -hoursDiff : hoursDiff;
    const minutesToAdd = diffMinutes < 0 ? -minutesDiff : minutesDiff;

    const [startTime, endTime] = timeString.split(' - ');

    function offsetTime(time) {
      const [timePart, meridiem] = time.split(' ');
      let [hours, minutes] = timePart.split(':').map(num => parseInt(num, 10));

      if (meridiem === 'PM' && hours !== 12) {
        hours += 12;
      } else if (meridiem === 'AM' && hours === 12) {
        hours = 0;
      }

      let totalMinutes = hours * 60 + minutes + hoursToAdd * 60 + minutesToAdd;

      while (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }
      totalMinutes %= 24 * 60;

      const newHours = Math.floor(totalMinutes / 60);
      const newMinutes = totalMinutes % 60;
      let displayHours = newHours % 12;
      if (displayHours === 0) displayHours = 12;
      const newMeridiem = newHours >= 12 ? 'PM' : 'AM';
      return `${displayHours}:${newMinutes.toString().padStart(2, '0')} ${newMeridiem}`;
    }

    const newStartTime = offsetTime(startTime);
    const newEndTime = offsetTime(endTime);
    return `${newStartTime} - ${newEndTime}`;
  }

  return (
    <div className="pick-time-wrapper">
      <div className="pick-time-header">
        <h2>Pick a time</h2>
      </div>
      <div className="time-duration-tab">
        <div
          onClick={(e) => handleDuration(e, 0)}
          className={`${duration === 0 ? "active" : ""}`}
        >
          <p>15min</p>
        </div>
        <div
          onClick={(e) => handleDuration(e, 1)}
          className={`${duration === 1 ? "active" : ""}`}
        >
          <p>30min</p>
        </div>
      </div>
      <div className="time-slots" ref={timeSlotsRef}>
        {slots.map((slot, index) => {
          const isDisabled = isSlotDisabled(slot) ? "time-slot-disabled" : "";
          const convertedSlot = convertTimeZone(slot, selectedTimeZone, "GMT+5:30");

          return (
            <div
              key={index}
              onClick={(e) => handleClick(e, index + 1)}
              className={`time-slot ${timeSlot === index + 1 ? "time-slot-picked" : ""
                } ${isDisabled}`}
              style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
            >
              <p>{convertedSlot}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

//optionlist of every question
export const jobTitles = [
  { value: "Business Owner/Leader", label: "Business Owner/Leader" },
  {
    value: "C-Suite (CEO, CTO, COO, CFO, CIO)",
    label: "C-Suite (CEO, CTO, COO, CFO, CIO)",
  },
  { value: "Vice-President", label: "Vice-President" },
  { value: "Director", label: "Director" },
  { value: "Program Manager", label: "Program Manager" },
  { value: "Head of Function", label: "Head of Function" },
  { value: "Subject Matter Expert", label: "Subject Matter Expert" },
  { value: "Senior Consultant/Engineer", label: "Senior Consultant/Engineer" },
  { value: "Other", label: "Other" },
];

export const countries = [
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas", label: "Bahamas" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Benin", label: "Benin" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Brazil", label: "Brazil" },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Burkina Faso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "Cabo Verde", label: "Cabo Verde" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Canada", label: "Canada" },
  { value: "Central African Republic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  { value: "Congo", label: "Congo" },
  { value: "Costa Rica", label: "Costa Rica" },
  { value: "Croatia", label: "Croatia" },
  { value: "Cuba", label: "Cuba" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "Czech Republic", label: "Czech Republic" },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "El Salvador", label: "El Salvador" },
  { value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Eswatini", label: "Eswatini" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Fiji", label: "Fiji" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Greece" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  { value: "Honduras", label: "Honduras" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "North Korea", label: "North Korea" },
  { value: "South Korea", label: "South Korea" },
  { value: "Kosovo", label: "Kosovo" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "Marshall Islands", label: "Marshall Islands" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "North Macedonia", label: "North Macedonia" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palau", label: "Palau" },
  { value: "Panama", label: "Panama" },
  { value: "Papua New Guinea", label: "Papua New Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
  { value: "Saint Lucia", label: "Saint Lucia" },
  {
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  { value: "Samoa", label: "Samoa" },
  { value: "San Marino", label: "San Marino" },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbia" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "Sierra Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "Solomon Islands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "South Africa", label: "South Africa" },
  { value: "South Sudan", label: "South Sudan" },
  { value: "Spain", label: "Spain" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Sudan", label: "Sudan" },
  { value: "Suriname", label: "Suriname" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Timor-Leste", label: "Timor-Leste" },
  { value: "Togo", label: "Togo" },
  { value: "Tonga", label: "Tonga" },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "United States", label: "United States" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  { value: "Vatican City", label: "Vatican City" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Yemen", label: "Yemen" },
  { value: "Zambia", label: "Zambia" },
  { value: "Zimbabwe", label: "Zimbabwe" },
];

export const questionsList = [
  {
    question: "Which Industry best describes your organization?",
    answers: [
      "Banking",
      "Fintech",
      "Payment Providers",
      "Wealth Management",
      "Discrete Manufacturing",
      "Semiconductor",
      "Machinery Manufacturing / Automation",
      "Appliances / Electrical / Electronics",
      "Elevator Manufacturing",
      "Defense & Space Manufacturing",
      "Computers & Electronics / Industrial Machinery",
      "Motor Vehicle Manufacturing",
      "Food and Beverages",
      "Distillery & Wines",
      "Beverages",
      "Shipping",
      "Logistics",
      "Mobility (EV / Public Transport)",
      "Energy & Utilities",
      "Hospitality",
      "Digital Gaming Platforms",
      "SportsTech with AI",
      "Public Safety - Explosives",
      "Public Safety - Firefighting",
      "Public Safety - Surveillance",
      "Public Safety - Others",
      "Media Platforms",
      "City Operations",
      "Airlines & Aviation",
      "Defense Warfare & Drones",
      "Robotics Engineering",
      "Drones Manufacturing",
      "AI Labs for Colleges",
      "AI MSP / Quantum / AGI Institutes",
      "Retail Apparel and Fashion",
    ],
  },
  {
    question: "What is your Key focus areas?",
    answers: [
      "AI Workflow and Operations",
      "Data Management and Operations",
      "AI Governance",
      "Analytics and Insights",
      "Observability",
      "Security Operations",
      "Risk and Compliance",
      "Procurement and Supply Chain",
      "Private Cloud AI",
      "Vision AI",
    ],
  },
  {
    question: "In Which Agentic Platform and Accelerator you are Interested?",
    answers: [
      "Akira AI - Agentic AI Platform Multi Agent System",
      "Metasecure - Autonomous SOC",
      "Nexastack – Build and Managed Compound AI Stack",
      "Data Foundry",
      "XAI – Vision and AI Platform – Visual AI Agents",
      "Strategy Consulting",
      "AI Managed Services",
    ],
  },
  {
    question: "Which segment does your company belong to?",
    answers: [
      "Startup",
      "Scale Startup",
      "SME",
      "Mid Enterprises",
      "Large Enterprises",
      "Federal Government",
      "Non Profits",
    ],
  },
  {
    question: "At what stage is your AI use case currently in?",
    answers: [
      "Conceptualized: Use case defined, PoC pending",
      "POC Completed",
      "In Production with challenges",
      "Not yet defined",
    ],
  },
  {
    question: "What are the primary challenges in adopting AI?",
    answers: [
      "Data Quality Issues",
      "Data Privacy and Compliance",
      "Aligning AI with business goals",
      "Unclear ROI from POCs",
      "Integration with existing ERP systems",
      "Scalability Challenges",
      "Moving POCs in Production",
      "Infrastructure Limitation",
      "High Implementation costs",
    ],
  },
  {
    question:
      "What kind of infrastructure does your organization currently using?",
    answers: [
      "AWS",
      "Microsoft Azure",
      "GCP",
      "IBM Cloud",
      "Oracle Cloud",
      "On Premises",
    ],
  },
  {
    question: "Are you using any Data platform?",
    answers: [
      "Databricks",
      "SnowFlake",
      "Amazon Redshift",
      "Azure Synapse Analytics",
      "Microsoft Fabric",
      "Teradata",
      "Oracle Database",
      "SAP Hana",
      "Informatica",
      "Google Cloud BigQuery",
    ],
  },
  {
    question: "Preferred Approach for AI Transformation",
    answers: [
      "Assisted Intelligence Agents as Co-Pilot",
      "Collaborative Intelligence Agents as AI Teammates",
      "Autonomous Intelligence Agents – AI Agents",
      "Agentic Actions",
      "Agentic Process Automation",
    ],
  },
  {
    question:
      "In Which Domain your Solution/Organization belongs to in-terms of Data Privacy, Trustworthy AI",
    answers: [
      "Internal Organization",
      "Highly Regulated Industry (Healthcare, Financials etc)",
      "Medium Regulated",
      "Non Regulated",
    ],
  },
];

export const timeSlots = [
  [
    "9:00 AM - 9:15 AM",
    "9:15 AM - 9:30 AM",
    "9:30 AM - 9:45 AM",
    "9:45 AM - 10:00 AM",
    "10:00 AM - 10:15 AM",
    "10:15 AM - 10:30 AM",
    "10:30 AM - 10:45 AM",
    "10:45 AM - 11:00 AM",
    "11:00 AM - 11:15 AM",
    "11:15 AM - 11:30 AM",
    "11:30 AM - 11:45 AM",
    "11:45 AM - 12:00 PM",
    "12:00 PM - 12:15 PM",
    "12:15 PM - 12:30 PM",
    "12:30 PM - 12:45 PM",
    "12:45 PM - 1:00 PM",
    "1:00 PM - 1:15 PM",
    "1:15 PM - 1:30 PM",
    "1:30 PM - 1:45 PM",
    "1:45 PM - 2:00 PM",
    "2:00 PM - 2:15 PM",
    "2:15 PM - 2:30 PM",
    "2:30 PM - 2:45 PM",
    "2:45 PM - 3:00 PM",
    "3:00 PM - 3:15 PM",
    "3:15 PM - 3:30 PM",
    "3:30 PM - 3:45 PM",
    "3:45 PM - 4:00 PM",
    "4:00 PM - 4:15 PM",
    "4:15 PM - 4:30 PM",
    "4:30 PM - 4:45 PM",
    "4:45 PM - 5:00 PM",
    "5:00 PM - 5:15 PM",
    "5:15 PM - 5:30 PM",
    "5:30 PM - 5:45 PM",
    "5:45 PM - 6:00 PM",
    "6:00 PM - 6:15 PM",
    "6:15 PM - 6:30 PM",
    "6:30 PM - 6:45 PM",
    "6:45 PM - 7:00 PM",
    "7:00 PM - 7:15 PM",
    "7:15 PM - 7:30 PM",
    "7:30 PM - 7:45 PM",
    "7:45 PM - 8:00 PM",
    "8:00 PM - 8:15 PM",
    "8:15 PM - 8:30 PM",
    "8:30 PM - 8:45 PM",
    "8:45 PM - 9:00 PM",
    "9:00 PM - 9:15 PM",
    "9:15 PM - 9:30 PM",
    "9:30 PM - 9:45 PM",
    "9:45 PM - 10:00 PM",
  ],

  [
    "9:00 AM - 9:30 AM",
    "9:30 AM - 10:00 AM",
    "10:00 AM - 10:30 AM",
    "10:30 AM - 11:00 AM",
    "11:00 AM - 11:30 AM",
    "11:30 AM - 12:00 PM",
    "12:00 PM - 12:30 PM",
    "12:30 PM - 1:00 PM",
    "1:00 PM - 1:30 PM",
    "1:30 PM - 2:00 PM",
    "2:00 PM - 2:30 PM",
    "2:30 PM - 3:00 PM",
    "3:00 PM - 3:30 PM",
    "3:30 PM - 4:00 PM",
    "4:00 PM - 4:30 PM",
    "4:30 PM - 5:00 PM",
    "5:00 PM - 5:30 PM",
    "5:30 PM - 6:00 PM",
    "6:00 PM - 6:30 PM",
    "6:30 PM - 7:00 PM",
    "7:00 PM - 7:30 PM",
    "7:30 PM - 8:00 PM",
    "8:00 PM - 8:30 PM",
    "8:30 PM - 9:00 PM",
    "9:00 PM - 9:30 PM",
    "9:30 PM - 10:00 PM",
  ],
];
export const dept=[
  { value: "IT", label: "IT (Information Technology)" },
  { value: "Finance",label: "Finance"},
  { value: "Human Resources", label: "Human Resources" },
  { value: "Marketing", label: "Marketing" },
  { value: "Sales", label: "Sales" },
  { value: "Operations", label: "Operations" },
  { value: "Research and Development", label: "Research and Development" },
  { value: "Customer Support", label: "Customer Support" },
  { value: "Other", label: "Other" },
]